// CMYK color type

export type CMYKColor = {
  alpha: number // alpha (0-1)
  cyan: number // cyan (0-1)
  black: number // key/black (0-1)
  magenta: number // magenta (0-1)
  yellow: number // yellow (0-1)
}
